/**
 * TemplateIds for specific entities
 */
export const hsePlanTemplateId = 285878;
export const employeeInterviewTemplateId = 9850;
export const riskLevelTemplateId = 470866;
export const issueGuidelineTemplateId = 781;
export const hseReviewTemplateId = 478935;
